export class EdiSendType {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = name
  }
}

export const EDI_ORIGINAL_FTP_EXPORT = new EdiSendType(1, 'EDI提单（原始）- FTP导出')
export const EDI_ORIGINAL_FTP_SEND = new EdiSendType(2, 'EDI提单（原始）- FTP 发送')
export const EDI_ORIGINAL_API = new EdiSendType(3, 'EDI提单（原始）- API')
export const EDI_UPDATE_FTP_EXPORT = new EdiSendType(4, 'EDI提单（更正）- FTP导出')
export const EDI_UPDATE_FTP_SEND = new EdiSendType(5, 'EDI提单（更正）- FTP 发送')
export const EDI_UPDATE_API = new EdiSendType(6, 'EDI提单（更正）- FTP 发送')
export const EDI_UPDATE_FTP_TZ_START = new EdiSendType(7, '田泽外部EDI推送开始')
export const EDI_UPDATE_FTP_TZ_END = new EdiSendType(8, '田泽外部EDI推送结束')
